import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {discoveryActions, alertActions} from '../../../_services/essentials/store';
import * as Yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";
import {history} from "../../../_services/essentials/helpers";
import { TextField, Button, Stack, FormControl} from '@mui/material';
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";


export { Filter };

function Filter() {
    const dispatch = useDispatch();
    const entity = useSelector(x => x.discovery?.filter);

    // form validation rulesspecialities
    const validationSchema = Yup.object().shape({
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset } = useForm(formOptions);

    useEffect(() => {
        dispatch(discoveryActions.getAllSpecialities()).unwrap()
            .then(entity => {
                reset(entity);
            });
        dispatch(discoveryActions.getAllContinents()).unwrap()
            .then(entity => {
                reset(entity);
            });
        dispatch(discoveryActions.getAllSearchTerms()).unwrap()
            .then(entity => {
                reset(entity);
            });

        dispatch(discoveryActions.getAllProfessionalActivities()).unwrap();
        dispatch(discoveryActions.getAllProfileCompletenessOptions()).unwrap();

    }, [dispatch, reset]);

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // redirect to user list with success message
            history.navigate(`/master_profiles`);
            //dispatch(alertActions.success({ message, showAfterRedirect: true }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (

        <React.Fragment>
            <Stack direction="column" sx={{flexGrow: '1', gap: 1}}>
                <Stack sx={{justifyContent: 'space-between', flexGrow: '1', gap: 1, mt:4}}>
                </Stack>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {!(entity?.specialities?.value?.loading || entity?.value?.specialities.value?.error) &&
                    <FormControl>
                        <Stack direction="column" sx={{flexGrow: '1', gap: 1, mb: 3, ml: 2 }}>
                            <Stack sx={{flexGrow: '1'}}>
                                <Typography component="h4" variant="h6" sx={{ fontSize: 18 }}>
                                    Choose your specialty of the KOLs
                                </Typography>
                            </Stack>
                            <Stack direction="row" sx={{flexGrow: '1', ml: 2 }}>
                                {entity?.specialities?.value?.map((speciality, index) => (
                                    <FormControlLabel control={<Checkbox defaultChecked={speciality.selected} {...register(`entity.specialities.${index}.selected`)} />} key={`${speciality.id}`} label={`${speciality.name}`} />
                                ))}
                            </Stack>
                        </Stack>
                    </FormControl>
                    }
                    {!(entity?.countries?.value?.loading || entity?.countries?.value?.error) &&
                    <FormControl>
                        <Stack direction="column" sx={{flexGrow: '1', gap: 1, mb: 3, ml: 2}}>
                            <Stack sx={{flexGrow: '1', gap: 1}}>
                                <Typography component="h4" variant="h6" sx={{ fontSize: 18 }}>
                                    Choose your Geographic location preference of the KOLs
                                </Typography>
                            </Stack>
                            <Stack direction="row" sx={{flexGrow: '1', ml: 2}}>
                                {entity?.countries?.value?.map((country, index) => (
                                    <FormControlLabel control={<Checkbox defaultChecked={country.selected} {...register(`entity.countries.${index}.selected`)} />} key={`${country.id}`} label={`${country.name}`} />
                                ))}
                            </Stack>
                        </Stack>
                    </FormControl>
                    }
                    {!(entity?.search_terms?.value?.loading || entity?.search_terms?.value?.error) &&
                    <FormControl>
                        <Stack direction="column" sx={{flexGrow: '1', gap: 1, mb: 2, ml: 2}}>
                            <Stack sx={{justifyContent: 'space-between', flexGrow: '1', gap: 1}}>
                                <Typography component="h4" variant="h6" sx={{fontSize: 18}}>
                                    Enter your therapeutic areas or MeSH terms [each term followed by comma(,)]
                                </Typography>
                            </Stack>
                            <Stack sx={{justifyContent: 'space-between', flexGrow: '1', ml: 2}}>
                                <TextField
                                    id="description"
                                    name="description"
                                    type="text"
                                    variant='outlined'
                                    color='primary'
                                    fullWidth
                                    multiline
                                    size="normal"
                                    rows={2}
                                    sx={{mb: 4}}
                                    inputlabelprops={{shrink: true}}
                                    {...register('search_terms')}
                                />
                            </Stack>
                        </Stack>
                    </FormControl>
                    }
                    {/*<FormControl fullWidth={true}>*/}
                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1, ml: 2}} spacing={2}>
                        <Button variant="contained" color="primary" type="submit" sx={{mb: 4}} >Discover</Button>
                    </Stack>
                    {/*</FormControl>*/}
                </form>
            </Stack>
        </React.Fragment>
    );
}
